import { cpf } from 'cpf-cnpj-validator';
import { createMask } from 'imask';
import React, { ChangeEvent, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { FaArrowRight } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { errorToast } from '../../utils/toast';
import { Content } from '../BodyStep/styles';
import Button from '../Button';
import Input from '../Input';
import { FormContent } from './styles';

const maskCpf = createMask({
  mask: '000.000.000-00',
});

const Identification: React.FC = () => {
  const {
    handleChangeCurrentStep,
    documentNum,
    name,
    handleSetDocument,
    handleSetName,
  } = useSteps();

  const { handleSubmit } = useForm();

  const handleValidate = useCallback(() => {
    if (name === '') {
      errorToast({ message: 'Nome é obrigatório!' });
      return;
    }

    if (!cpf.isValid(documentNum)) {
      errorToast({ message: 'Documento inválido!' });
      return;
    }

    handleChangeCurrentStep();
  }, [documentNum, name]);

  const setCpf = (e: ChangeEvent<HTMLInputElement>) => {
    e.target.value = maskCpf.resolve(e.target.value);
    handleSetDocument(e.target.value);
  };

  return (
    <Content>
      <Title>Dados Pessoais</Title>
      <FormContent onSubmit={handleSubmit(handleValidate)}>
        <Input
          type="text"
          label="Nome Completo"
          onChange={e => handleSetName(e.target.value)}
          value={name}
          width="70%"
        />
        <Input
          type="tel"
          label="Número do CPF"
          onChange={e => setCpf(e)}
          value={documentNum}
          width="40%"
        />
        <Button title="Próximo" type="submit" icon={FaArrowRight} />
      </FormContent>
    </Content>
  );
};

export default Identification;
